import { render } from "./AddProductCategory.vue?vue&type=template&id=1f831909&scoped=true"
import script from "./AddProductCategory.vue?vue&type=script&lang=js"
export * from "./AddProductCategory.vue?vue&type=script&lang=js"

import "./AddProductCategory.vue?vue&type=style&index=0&id=1f831909&lang=scss&scoped=true"

import exportComponent from "/home/hulk-suman/Music/Insidejob-admin-devlopment-1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f831909"]])

export default __exports__